import { splitProps, type JSX } from "solid-js";
import { cn } from "@/lib/cn";

export type InputProps = JSX.InputHTMLAttributes<HTMLInputElement>;

export function Input(props: InputProps) {
  const [local, rest] = splitProps(props, ["class", "type"]);
  return (
    <input
      type={local.type ?? "text"}
      class={cn(
        "flex h-10 w-full rounded border border-input bg-background px-3 py-2 text-sm transition-colors duration-150 ease-control",
        "ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium",
        "placeholder:text-muted-foreground focus-visible:outline-none",
        "focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        "disabled:cursor-not-allowed disabled:opacity-50 motion-reduce:transition-none",
        local.class,
      )}
      {...rest}
    />
  );
}
